import { type ReactNode } from "react";

export const PageHeader = ({
  eyebrow,
  title,
  children,
  actions,
}: {
  eyebrow: string;
  title: string;
  children?: ReactNode;
  actions?: ReactNode;
}) => (
  <header className="flex flex-wrap items-end justify-between gap-4">
    <div className="max-w-2xl">
      <p className="text-xs font-semibold uppercase tracking-widest text-muted">{eyebrow}</p>
      <h1 className="font-serif text-3xl text-ink">{title}</h1>
      {children && <div className="mt-2 text-sm text-muted">{children}</div>}
    </div>
    {actions && <div className="flex gap-2">{actions}</div>}
  </header>
);

export const ErrorText = ({ children }: { children: ReactNode }) => (
  <p role="alert" className="text-sm text-red-600">
    {children}
  </p>
);

export const selectClass =
  "h-9 w-full rounded-md border border-line bg-white px-2 text-sm text-ink focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/20 disabled:bg-paper";
